import * as React from "react";
import { forwardRef } from "react";
const SvgBack = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 13 22" ref={ref} {...props}><path stroke="#0F93F5" strokeWidth={2} d="M11.5 1.5 2 11l9.5 9.5" /></svg>;
const ForwardRef = forwardRef(SvgBack);
export default ForwardRef;